// import "../build/style-index.css"

// Our modules / classes
import Search from "../src/modules/Search"
import Header from "../src/modules/Header"

//Instantiate a new object using our modules/classes
const magicalSearch = new Search();
const hamburgerMenu = new Header();